import React, { useEffect, useState, useRef } from 'react'
import { Tile, Form, FormGroup, TextInput, Button, Select, SelectItem } from 'carbon-components-react'
import { deNormalizePhone } from '../../utils/functions/tools/normalizePhone'
import { ClientAddresses } from './clientAddresses.tsx'
import { ClientPhoneNumbers } from './clientPhoneNumbers.tsx'
import { ClientEmailAddresses } from './clientEmailAddresses.tsx'

const ClientDetails = (pageData) => {

  // For Addresses
  const [totalItems, setTotalItems] = useState(0);
  const [firstRowIndex, setFirstRowIndex] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(10);

  const [editAddressRecord, setEditAddressRecord] = useState(null);
  const [editError, setEditError] = useState(false);

  const [openAddAddressModal, setOpenAddAddressModal] = useState(false);
  const [openEditAddressModal, setOpenEditAddressModal] = useState(false);

  const addAddressForm = useRef();
  const editAddressForm = useRef();

  let [openDeleteAddressModal, setOpenDeleteAddressModal] = useState(false)
  let [addressesToDel, setAddressesToDel] = useState(null)

  // For PhoneNumbers
  const [totalPhoneItems, setTotalPhoneItems] = useState(0);
  const [firstRowPhoneIndex, setFirstRowPhoneIndex] = useState(0);
  const [currentPhonePageSize, setPhoneCurrentPageSize] = useState(10);
  const [phoneInput, setPhoneInput] = useState("");

  const [editPhoneRecord, setEditPhoneRecord] = useState(null);
  const [editPhoneInput, setEditPhoneInput] = useState("");

  const [openAddPhoneModal, setOpenAddPhoneModal] = useState(false);
  const [openEditPhoneModal, setOpenEditPhoneModal] = useState(false);

  const addPhoneForm = useRef();
  const editPhoneForm = useRef();

  let [openDeletePhoneModal, setOpenDeletePhoneModal] = useState(false)
  let [phonesToDel, setPhonesToDel] = useState(null)

  // For Email Addresses
  const [totalEmailItems, setTotalEmailItems] = useState(0);
  const [firstRowEmailIndex, setFirstRowEmailIndex] = useState(0);
  const [currentEmailPageSize, setEmailCurrentPageSize] = useState(10);
  const [EmailInput, setEmailInput] = useState("");

  const [editEmailRecord, setEditEmailRecord] = useState(null);
  const [editEmailInput, setEditEmailInput] = useState("");

  const [openAddEmailModal, setOpenAddEmailModal] = useState(false);
  const [openEditEmailModal, setOpenEditEmailModal] = useState(false);

  const addEmailForm = useRef();
  const editEmailForm = useRef();

  let [openDeleteEmailModal, setOpenDeleteEmailModal] = useState(false)
  let [emailToDel, setEmailToDel] = useState(null)

  // General
  const [curDate, setCurDate] = useState(null)

  useEffect(() => {
    setTotalItems(pageData.clientAddresses?.length)
    setTotalPhoneItems(pageData.clientPhoneNumbers?.length)
    setTotalEmailItems(pageData.clientEmailAddresses?.length)
    let date = new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).slice(-2) + '-' + ('0' + new Date().getDate()).slice(-2)
    setCurDate(date)
  }, [])

  let addAddress = async (values) => {
    values.preventDefault()

    let response = await fetch(`${pageData.API_URL}/client/profile/address/${pageData.profileId}/`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + pageData.authTokens?.access
      },
      body: JSON.stringify({
        'address1': values.target.address1.value,
        'address2': values.target.address2.value,
        'city': values.target.city.value,
        'province': values.target.province.value,
        'country': values.target.country.value,
        'postalcode': values.target.postalcode.value,
        'startDate': values.target.startDate.value,
        'endDate': values.target.endDate.value,
        'type': values.target.type.value,
        'client': pageData.profileId
      })
    })

    if (response.status === 200) {
      pageData.getClientAddresses(pageData.profileId, pageData.setClientAddresses, pageData.API_URL, pageData.authTokens, setTotalItems)
      pageData.getClient(pageData.profileId, pageData.setClient, pageData.setClientAddress, pageData.setClientMailingAddress, pageData.setClientBillingAddress, pageData.API_URL, pageData.authTokens, pageData.setClientCountry)
      setOpenAddAddressModal(false)
      pageData.showToast("success", "Success", "Client address has been added.")
      setEditError(false)
    } else {
      setEditError(true)
    }
  }

  let editAddressSetup = async (id) => {
    pageData.clientAddresses?.map((address) => { address.id === id && setEditAddressRecord(address) }
    )
  }

  let editAddress = async (values) => {
    values.preventDefault()

    let endDate = null

    if (values.target.endDate.value === "") {
      endDate = null
    } else {
      endDate = values.target.endDate.value
    }

    let response = await fetch(`${pageData.API_URL}/client/profile/address/${editAddressRecord.id}/`, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + pageData.authTokens?.access
      },
      body: JSON.stringify({
        'address1': values.target.address1.value,
        'address2': values.target.address2.value,
        'city': values.target.city.value,
        'province': values.target.province.value,
        'country': values.target.country.value,
        'postalcode': values.target.postalcode.value,
        'startDate': values.target.startDate.value,
        'endDate': endDate,
        'type': values.target.type.value,
        'client': pageData.profileId
      })
    })

    if (response.status === 200) {
      pageData.getClientAddresses(pageData.profileId, pageData.setClientAddresses, pageData.API_URL, pageData.authTokens, setTotalItems)
      pageData.getClient(pageData.profileId, pageData.setClient, pageData.setClientAddress, pageData.setClientMailingAddress, pageData.setClientBillingAddress, pageData.API_URL, pageData.authTokens, pageData.setClientCountry)
      setOpenEditAddressModal(false)
      pageData.showToast("success", "Success", "Client address has been added.")
      setEditError(false)
    } else {
      setEditError(true)
    }
  }

  let deleteAddress = async (id) => {
    let response = await fetch(`${pageData.API_URL}/client/profile/address/${id}/`, {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + pageData.authTokens?.access
      },
    })

    if (response.status === 200) {
      pageData.getClientAddresses(pageData.profileId, pageData.setClientAddresses, pageData.API_URL, pageData.authTokens, setTotalItems)
      pageData.getClient(pageData.profileId, pageData.setClient, pageData.setClientAddress, pageData.setClientMailingAddress, pageData.setClientBillingAddress, pageData.API_URL, pageData.authTokens, pageData.setClientCountry)
      pageData.showToast("success", "Success", "Client address has been deleted.")
      setOpenDeleteAddressModal(false)
      setEditError(false)
    } else {
      setEditError(true)
    }
  }

  let addPhone = async (values) => {
    values.preventDefault()

    let response = await fetch(`${pageData.API_URL}/client/profile/phone/${pageData.profileId}/`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + pageData.authTokens?.access
      },
      body: JSON.stringify({
        'phoneNumber': deNormalizePhone(values.target.phoneNumber.value),
        'startDate': values.target.startDate.value,
        'endDate': values.target.endDate.value,
        'type': values.target.type.value,
        'client': pageData.profileId
      })
    })

    if (response.status === 200) {
      pageData.getClientPhoneNumbers(pageData.profileId, pageData.setClientPhoneNumbers, pageData.API_URL, pageData.authTokens)
      pageData.getClient(pageData.profileId, pageData.setClient, pageData.setClientAddress, pageData.setClientMailingAddress, pageData.setClientBillingAddress, pageData.API_URL, pageData.authTokens, pageData.setClientCountry)
      setOpenAddPhoneModal(false)
      pageData.showToast("success", "Success", "Client phone number has been added.")
      setEditError(false)
    } else {
      setEditError(true)
    }
  }

  let editPhoneSetup = async (id) => {
    pageData.clientPhoneNumbers?.map((phone) => { phone.id === id && setEditPhoneRecord(phone) }
    )
    pageData.clientPhoneNumbers?.map((phone) => { phone.id === id && setEditPhoneInput(phone.phoneNumber) }
    )
  }

  let editPhone = async (values) => {
    values.preventDefault()

    let endDate = null

    if (values.target.endDate.value === "") {
      endDate = null
    } else {
      endDate = values.target.endDate.value
    }

    let response = await fetch(`${pageData.API_URL}/client/profile/phone/${pageData.profileId}/`, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + pageData.authTokens?.access
      },
      body: JSON.stringify({
        'phoneNumber': deNormalizePhone(values.target.phoneNumber.value),
        'startDate': values.target.startDate.value,
        'endDate': endDate,
        'type': values.target.type.value,
        'client': pageData.profileId
      })
    })

    if (response.status === 200) {
      pageData.getClientPhoneNumbers(pageData.profileId, pageData.setClientPhoneNumbers, pageData.API_URL, pageData.authTokens)
      pageData.getClient(pageData.profileId, pageData.setClient, pageData.setClientAddress, pageData.setClientMailingAddress, pageData.setClientBillingAddress, pageData.API_URL, pageData.authTokens, pageData.setClientCountry)
      setOpenEditPhoneModal(false)
      pageData.showToast("success", "Success", "Client phone number has been edited.")
      setEditError(false)
    } else {
      setEditError(true)
    }
  }

  let deletePhone = async (id) => {
    let response = await fetch(`${pageData.API_URL}/client/profile/phone/${id}/`, {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + pageData.authTokens?.access
      },
    })

    if (response.status === 200) {
      pageData.getClientPhoneNumbers(pageData.profileId, pageData.setClientPhoneNumbers, pageData.API_URL, pageData.authTokens)
      pageData.getClient(pageData.profileId, pageData.setClient, pageData.setClientAddress, pageData.setClientMailingAddress, pageData.setClientBillingAddress, pageData.API_URL, pageData.authTokens, pageData.setClientCountry)
      setOpenDeletePhoneModal(false)
      pageData.showToast("success", "Success", "Client phone number has been deleted.")
    } else {
      pageData.showToast("error", "Error", "Unable to delete client phone number. Please try again.")
    }
  }

  let addEmail = async (values) => {
    values.preventDefault()

    let response = await fetch(`${pageData.API_URL}/client/profile/email/${pageData.profileId}/`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + pageData.authTokens?.access
      },
      body: JSON.stringify({
        'email': values.target.email.value,
        'startDate': values.target.startDate.value,
        'endDate': values.target.endDate.value,
        'type': values.target.type.value,
        'client': pageData.profileId
      })
    })

    if (response.status === 200) {
      pageData.getClientEmailAddresses(pageData.profileId, pageData.setClientEmailAddresses, pageData.API_URL, pageData.authTokens)
      pageData.getClient(pageData.profileId, pageData.setClient, pageData.setClientAddress, pageData.setClientMailingAddress, pageData.setClientBillingAddress, pageData.API_URL, pageData.authTokens, pageData.setClientCountry)
      setOpenAddEmailModal(false)
      pageData.showToast("success", "Success", "Client email address has been added.")
      setEditError(false)
    } else {
      setEditError(true)
    }
  }

  let editEmailSetup = async (id) => {
    pageData.clientEmailAddresses?.map((email) => { email.id === id && setEditEmailRecord(email) }
    )
  }

  let editEmail = async (values) => {
    values.preventDefault()

    let endDate = null

    if (values.target.endDate.value === "") {
      endDate = null
    } else {
      endDate = values.target.endDate.value
    }

    let response = await fetch(`${pageData.API_URL}/client/profile/email/${pageData.profileId}/`, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + pageData.authTokens?.access
      },
      body: JSON.stringify({
        'email': values.target.email.value,
        'startDate': values.target.startDate.value,
        'endDate': endDate,
        'type': values.target.type.value,
        'client': pageData.profileId
      })
    })

    if (response.status === 200) {
      pageData.getClientEmailAddresses(pageData.profileId, pageData.setClientEmailAddresses, pageData.API_URL, pageData.authTokens)
      pageData.getClient(pageData.profileId, pageData.setClient, pageData.setClientAddress, pageData.setClientMailingAddress, pageData.setClientBillingAddress, pageData.API_URL, pageData.authTokens, pageData.setClientCountry)
      setOpenEditEmailModal(false)
      pageData.showToast("success", "Success", "Client email address has been edited.")
      setEditError(false)
    } else {
      setEditError(true)
    }
  }

  let deleteEmail = async (id) => {
    let response = await fetch(`${pageData.API_URL}/client/profile/email/${id}/`, {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + pageData.authTokens?.access
      },
    })

    if (response.status === 200) {
      pageData.getClientEmailAddresses(pageData.profileId, pageData.setClientEmailAddresses, pageData.API_URL, pageData.authTokens)
      pageData.getClient(pageData.profileId, pageData.setClient, pageData.setClientAddress, pageData.setClientMailingAddress, pageData.setClientBillingAddress, pageData.API_URL, pageData.authTokens, pageData.setClientCountry)
      setOpenDeleteEmailModal(false)
      pageData.showToast("success", "Success", "Client email address has been deleted.")
    } else {
      pageData.showToast("error", "Error", "Unable to delete client email address. Please try again.")
    }
  }

  return (
    <>
      <Tile light={true} className="row">
        <h5 className="tile-title">Details</h5>
        <Form onSubmit={pageData.editClient}>
          <FormGroup className="d-flex flex-w">
            <div className="col-12 col-md-6 m-005">
              <TextInput
                required
                id="company"
                invalidText="Company name is required"
                labelText="Company Name"
                placeholder="Enter the company name"
                defaultValue={pageData.client?.company}
              />
            </div>
            <div className="col-12 col-md-6 m-005">
              <Select labelText="Primary Contact" name="primary" id="primary" defaultValue={pageData.client?.primary}>
                {pageData.contacts?.map((contact, index) => (
                  <SelectItem key={index} value={contact.id} text={contact.first_name + ' ' + contact.last_name + ' (' + contact.position + ')'} />
                ))}
              </Select>
            </div>
            <div className="col-12 col-md-6 m-005">
              <Button type="submit">
                Save Changes
              </Button>
            </div>
          </FormGroup>
        </Form>
      </Tile>
      <Tile light={true} className="row">
        <h5 className="tile-title">Addresses</h5>
        <ClientAddresses setAddressesToDel={setAddressesToDel} addressesToDel={addressesToDel} setOpenDeleteAddressModal={setOpenDeleteAddressModal} openDeleteAddressModal={openDeleteAddressModal} deleteAddress={deleteAddress} curDate={curDate} innerRef={addAddressForm} addAddressForm={addAddressForm} addAddress={addAddress} countries={pageData.countries} rows={pageData.clientAddresses} totalItems={totalItems} currentPageSize={currentPageSize} setCurrentPageSize={setCurrentPageSize} setFirstRowIndex={setFirstRowIndex} openAddAddressModal={openAddAddressModal} setOpenAddAddressModal={setOpenAddAddressModal} openEditAddressModal={openEditAddressModal} setOpenEditAddressModal={setOpenEditAddressModal} editAddressRecord={editAddressRecord} editAddressRecord={editAddressRecord} editAddressSetup={editAddressSetup} editAddress={editAddress} editAddressForm={editAddressForm} editError={editError} setEditError={setEditError} />
      </Tile>
      <Tile light={true} className="row">
        <h5 className="tile-title">Phone Numbers</h5>
        <ClientPhoneNumbers setPhonesToDel={setPhonesToDel} phonesToDel={phonesToDel} setOpenDeletePhoneModal={setOpenDeletePhoneModal} openDeletePhoneModal={openDeletePhoneModal} editPhoneInput={editPhoneInput} setEditPhoneInput={setEditPhoneInput} deletePhone={deletePhone} phoneInput={phoneInput} setPhoneInput={setPhoneInput} deleteAddress={deleteAddress} curDate={curDate} innerRef={addPhoneForm} addPhoneForm={addPhoneForm} addPhone={addPhone} countries={pageData.countries} rows={pageData.clientPhoneNumbers} totalPhoneItems={totalPhoneItems} currentPhonePageSize={currentPhonePageSize} setPhoneCurrentPageSize={setPhoneCurrentPageSize} setFirstRowPhoneIndex={setFirstRowPhoneIndex} openAddPhoneModal={openAddPhoneModal} setOpenAddPhoneModal={setOpenAddPhoneModal} openEditPhoneModal={openEditPhoneModal} setOpenEditPhoneModal={setOpenEditPhoneModal} editPhoneRecord={editPhoneRecord} editPhoneRecord={editPhoneRecord} editPhoneSetup={editPhoneSetup} editPhone={editPhone} editPhoneForm={editPhoneForm} editError={editError} setEditError={setEditError} />
      </Tile>
      <Tile light={true} className="row">
        <h5 className="tile-title">Email Addresses</h5>
        <ClientEmailAddresses setEmailToDel={setEmailToDel} emailToDel={emailToDel} setOpenDeleteEmailModal={setOpenDeleteEmailModal} openDeleteEmailModal={openDeleteEmailModal} editEmailInput={editEmailInput} setEditEmailInput={setEditEmailInput} deleteEmail={deleteEmail} EmailInput={EmailInput} setEmailInput={setEmailInput} deleteAddress={deleteAddress} curDate={curDate} innerRef={addEmailForm} addEmailForm={addEmailForm} addEmail={addEmail} countries={pageData.countries} rows={pageData.clientEmailAddresses} totalEmailItems={totalEmailItems} currentEmailPageSize={currentEmailPageSize} setEmailCurrentPageSize={setEmailCurrentPageSize} setFirstRowEmailIndex={setFirstRowEmailIndex} openAddEmailModal={openAddEmailModal} setOpenAddEmailModal={setOpenAddEmailModal} openEditEmailModal={openEditEmailModal} setOpenEditEmailModal={setOpenEditEmailModal} editEmailRecord={editEmailRecord} editEmailRecord={editEmailRecord} editEmailSetup={editEmailSetup} editEmail={editEmail} editEmailForm={editEmailForm} editError={editError} setEditError={setEditError} />
      </Tile>
    </>
  )
}

export default ClientDetails